'use-client';
import * as React from 'react';
import type {
  ISlideShowGalleryImperativeActions,
  ISlideShowGalleryProps,
} from '../../../SlideShowGallery.types';
import SlideShowGallery from '../../SlideShowGallery';
import skinsItemStyle from '../../../../SlideShowGalleryItem/viewer/style/SlideShowTextBottomItem.scss';
import skinsStyle from './styles/SlideShowTextBottom.scss';

const SlideShowTextBottom: React.ForwardRefRenderFunction<
  ISlideShowGalleryImperativeActions,
  Omit<ISlideShowGalleryProps, 'skin'>
> = (props, ref) => (
  <SlideShowGallery
    ref={ref}
    {...props}
    skinsStyle={skinsStyle}
    skinsItemStyle={skinsItemStyle}
    renderNavigationButtonsInHelpers
  />
);

export default React.forwardRef(SlideShowTextBottom);
